module.exports = __webpack_public_path__ + "static/media/marketing_chat_dark.e53e6ac4.png";